module.exports = __webpack_public_path__ + "img/em7.7f50e614.jpg";